import styled, { css } from 'styled-components';

export const StyledIndicatorsList = styled.div<{ $twoColumns: boolean }>`
  display: ${({ $twoColumns }) => ($twoColumns ? 'grid' : 'flex')};
  ${({ $twoColumns }) => ($twoColumns
    ? css`
      grid-template-columns: repeat(2, minmax(0, 1fr));
      gap: var(--cl-space-2);
    `
    : css`
      flex-direction: column;
      gap: var(--cl-space-1);
    `)}
`;

export const StyledIndicatorRow = styled.div<{
  $isInteractive: boolean;
  $isSelected: boolean;
  $twoColumns: boolean;
}>`
  display: flex;
  align-items: center;
  gap: var(--cl-space-1);
  width: 100%;
  height: 32px;
  padding: var(--cl-space-1-5);
  box-sizing: border-box;
  background-color: var(--cl-gray-300);
  border-radius: var(--cl-radius-1);
  border: 1px solid transparent;
  color: var(--cl-text-default);
  font-size: var(--cl-font-size-2);
  font-weight: var(--cl-font-weight-regular);
  line-height: var(--cl-line-height-2);
  cursor: ${({ $isInteractive }) => ($isInteractive ? 'pointer' : 'default')};

  ${({ $twoColumns }) => $twoColumns && css`
    min-width: 0;
    overflow: hidden;
  `}

  ${({ $isSelected }) => $isSelected && css`
    border-color: var(--border-border-focused-juicyblue-600, #1D4ED8);
    box-shadow: 0 0 0 4px rgba(39, 85, 207, 0.20);
  `}
`;

export const StyledIndicatorLabel = styled.span<{ $twoColumns: boolean }>`
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  ${({ $twoColumns }) => $twoColumns && css`min-width: 0;`}
`;

export const StyledTooltipContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: var(--cl-space-2);
  max-width: 280px;
`;

export const StyledTooltipDirection = styled.div<{ $indicatesIncrease: boolean }>`
  display: flex;
  align-items: center;
  gap: var(--cl-space-1);
  font-size: var(--cl-font-size-2);
  color: ${({ $indicatesIncrease }) => ($indicatesIncrease ? 'var(--cl-red-500)' : 'var(--cl-green-500)')};
`;

export const StyledTooltipDescription = styled.span`
  font-size: var(--cl-font-size-2);
  line-height: var(--cl-line-height-2);
`;
